module.exports = __webpack_public_path__ + "img/bn0717.1038ff77.png";